export default __webpack_public_path__ + "static/learn-cover-7b21e3c585cd8d480528cc55d12470c4.jpg";